var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"mx-auto",staticStyle:{"margin-bottom":"120px"},attrs:{"contain":"","height":"10vh","src":require("@/assets/custom/images/login-logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }